import script from "./CategoryTreeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryTreeList.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryTreeList.vue?vue&type=style&index=0&id=59089864&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59089864"]])

export default __exports__